import { BACKEND_API_PLACEHOLDER } from "@/../environment.config";
import { fetchCurrentUserData } from "@/util/customFetch";

// sample data imports for offline dev purposes
const isOfflineDev = import.meta.env.VITE_OFFLINE_DEV === "true";

// Flip this to false when you are ready to point to the actual live backend
const useMocks = false;

const MOCK_SITE_COMMAND_INIT = {
  status: "success",
  message: "Site Command initializing on controller.",
  task_id: "job_site_command_init_abc123"
};

// Includes Input_Disabled so DiscreteInputItem enable/disable toggles render while mocking
const MOCK_SITE_COMMAND_FEATURES = [
  "Input_Disabled",
  "Output_0_ReadOnly",
];


let modulesSuccess = {};
if (isOfflineDev) {
  const mod = await import("@/tests/fixtures/Modules");
  modulesSuccess = mod.modulesSuccess;
}

export async function getSiteModules(headers) {
  if (!isOfflineDev) {
    let tokenData = await fetchCurrentUserData()
    headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + `/api/site/site_config?site_id=${headers.siteId}`, {
      method: 'GET',
      headers: headers,
    })
      .then(res => res.json()
      .then(data => { return data })
    )
  }
  else return modulesSuccess
}


export async function getSiteCommandId(headers) {
    let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
    return fetch(BACKEND_API_PLACEHOLDER + '/api/site/getSiteCommandId', {
      method: 'GET',
      headers: headers,
    })
      .then((res) => {
        return res.json()
      })
      .then((data) => {
        return data
      })
}

export async function getControllerStatus(headers) {
  return fetch(BACKEND_API_PLACEHOLDER + '/api/site/getControllerStatus', {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => {return data})
    )
}

export async function getRequestLogsQuery(query, headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  let url = BACKEND_API_PLACEHOLDER + '/api/site/requestLogsQuery?'
  for (const [idx, [category_name, category_value]] of Object.entries(Object.entries(query))) {
    if (!(category_value === 'null' || category_value === '')) url += `${idx > 0 ? '&' : ''}${category_name}=${category_value}`
  }
  return fetch(url, {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}

export async function getControllerConfig(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/site/getControllerConfig', {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => {return data})
    )
}

export async function getControllerVersions(headers) {
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/site/getControllerVersions', {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => {return data})
    )
}

export async function getSiteCommandFeatures(headers) {
  if (useMocks) {
    return Promise.resolve({
      status: 200,
      data: { results: MOCK_SITE_COMMAND_FEATURES },
    })
  }
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/site/getSiteCommandFeatures', {
    method: 'GET',
    headers: headers,
  })
    .then(res => res.json()
    .then(data => {return data})
    )
}

export async function postInitializeVersionedSiteCommand(postRequest, headers) {
  if (useMocks) {
    return Promise.resolve(MOCK_SITE_COMMAND_INIT);
  }
  let tokenData = await fetchCurrentUserData()
  headers = {...headers, ...tokenData}
  return fetch(BACKEND_API_PLACEHOLDER + '/api/site/initializeVersionedSiteCommand', {
    method: 'POST',
    body: JSON.stringify({postRequest}),
    headers: headers,
  })
    .then(res => res.json()
    .then(data => { return data })
  )
}